var React = require('react');

function PhotoEditing (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 16a2.99 2.99 0 012.816 2H21c.55 0 1 .45 1 1s-.45 1-1 1H10.816A2.99 2.99 0 018 22a2.99 2.99 0 01-2.816-2H3c-.55 0-1-.45-1-1s.45-1 1-1h2.184A2.99 2.99 0 018 16zm8-7c1.24 0 2.293.755 2.749 1.828l.067.172H21c.55 0 1 .45 1 1 0 .51-.388.935-.884.993L21 13h-2.184A2.99 2.99 0 0116 15a2.986 2.986 0 01-2.749-1.828L13.184 13H3c-.55 0-1-.45-1-1 0-.51.388-.935.884-.993L3 11h10.184A2.99 2.99 0 0116 9zM8 2c1.24 0 2.293.755 2.749 1.828l.067.172H21c.55 0 1 .45 1 1 0 .51-.388.935-.884.993L21 6H10.816A2.99 2.99 0 018 8a2.986 2.986 0 01-2.749-1.828L5.184 6H3c-.55 0-1-.45-1-1 0-.51.388-.935.884-.993L3 4h2.184A2.99 2.99 0 018 2z","fillRule":"evenodd"}));
}

PhotoEditing.defaultProps = {"width":"24","height":"24"};

module.exports = PhotoEditing;

PhotoEditing.default = PhotoEditing;
